// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { IntegratorDTO } from './integrator-dto';
import { OrderCustomerDTO } from './order-customer-dto';
import { OrderManualPaymentDTO } from './order-manual-payment-dto';
import { PolicyDTO } from './policy-dto';

/**
 * 
 * @export
 * @interface OrderWithOrderCustomersDTO
 */
export interface OrderWithOrderCustomersDTO {
    /**
     * 
     * @type {string}
     * @memberof OrderWithOrderCustomersDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrderWithOrderCustomersDTO
     */
    productId: OrderWithOrderCustomersDTOProductIdEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderWithOrderCustomersDTO
     */
    statusId: OrderWithOrderCustomersDTOStatusIdEnum;
    /**
     * 
     * @type {object}
     * @memberof OrderWithOrderCustomersDTO
     */
    details: object;
    /**
     * 
     * @type {number}
     * @memberof OrderWithOrderCustomersDTO
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof OrderWithOrderCustomersDTO
     */
    policyId?: string;
    /**
     * 
     * @type {PolicyDTO}
     * @memberof OrderWithOrderCustomersDTO
     */
    policy?: PolicyDTO;
    /**
     * 
     * @type {Array<PolicyDTO>}
     * @memberof OrderWithOrderCustomersDTO
     */
    policies?: Array<PolicyDTO>;
    /**
     * 
     * @type {string}
     * @memberof OrderWithOrderCustomersDTO
     */
    redirectUrl: string;
    /**
     * 
     * @type {string}
     * @memberof OrderWithOrderCustomersDTO
     */
    completedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderWithOrderCustomersDTO
     */
    integratorId?: string;
    /**
     * 
     * @type {IntegratorDTO}
     * @memberof OrderWithOrderCustomersDTO
     */
    integrator?: IntegratorDTO;
    /**
     * 
     * @type {Array<OrderManualPaymentDTO>}
     * @memberof OrderWithOrderCustomersDTO
     */
    manualPayments?: Array<OrderManualPaymentDTO>;
    /**
     * 
     * @type {string}
     * @memberof OrderWithOrderCustomersDTO
     */
    refundHandling?: OrderWithOrderCustomersDTORefundHandlingEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderWithOrderCustomersDTO
     */
    disputeHandling?: OrderWithOrderCustomersDTODisputeHandlingEnum;
    /**
     * 
     * @type {Array<OrderCustomerDTO>}
     * @memberof OrderWithOrderCustomersDTO
     */
    orderCustomers: Array<OrderCustomerDTO>;
}

/**
    * @export
    * @enum {string}
    */
export enum OrderWithOrderCustomersDTOProductIdEnum {
    REPOSIT = 'REPOSIT',
    CLAIM = 'CLAIM',
    CLAIMPROPOSAL = 'CLAIM_PROPOSAL',
    ARBITRATION = 'ARBITRATION',
    TOPUP = 'TOP_UP',
    ARBITRATIONADMINFEE = 'ARBITRATION_ADMIN_FEE'
}
/**
    * @export
    * @enum {string}
    */
export enum OrderWithOrderCustomersDTOStatusIdEnum {
    DRAFT = 'DRAFT',
    PENDING = 'PENDING',
    COMPLETE = 'COMPLETE',
    CANCELLED = 'CANCELLED',
    REFUNDED = 'REFUNDED'
}
/**
    * @export
    * @enum {string}
    */
export enum OrderWithOrderCustomersDTORefundHandlingEnum {
    MANUAL = 'MANUAL',
    AUTOMATIC = 'AUTOMATIC'
}
/**
    * @export
    * @enum {string}
    */
export enum OrderWithOrderCustomersDTODisputeHandlingEnum {
    MANUAL = 'MANUAL',
    AUTOMATIC = 'AUTOMATIC'
}



